import { lazy } from "react";

export const ClaimForm = lazy(() => import("./ClaimForm.tsx"));
